import styled from "styled-components"
import { Row, Card, Col, Button, ButtonProps } from "react-bootstrap"
import { FC } from "react"

export const ProductsGrid = styled(Row)`
  display: flex;
  flex-wrap: wrap;
`


export const ProductCardDiv = styled.div`
  color: #000;
  // background-color: #e0e0e0;
  border-radius: 5px;
  transition: all 0.3s ease;
  cursor: pointer;
  &:hover{
    transform: scale(1.05);
  }
`

export const StyledProductCard = styled(Card)`
  position: relative;
  padding: 0px;
  align-items: center;
  border: none;
`

export const StyledProductDetail = styled.div`
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 32px;
  display: flex;
  justify-content: center;
`

export const ProductCardImage = styled.img`
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  max-width: 100%;
`
export const StyledCardDiv = styled(Card.Body)`
  text-align: center;
`

export const ProductDetailPriceDiv = styled.div`
  background: url('/assets/svg/product-price.svg');
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  margin: 5px;
  padding-left: 10px;
  padding-right: 10px;
  display: block;
  color: #fff;
  font-size: 1em;
  width: max-content;
  border-radius: 10px;
}
`

export const StyledProductCardImage = styled(Card.Img)`
  height: 200px;
  width: 100%;
`

export const ProductPriceDiv = styled.div`
  width: 150px;
  background-color: #6531D9;
  border-radius: 10px;
  color: #fff;
  & img {
    display: inline;
  }
}
`

export const StyledHeader = styled(Row)`
white-space: nowrap;
justify-content: center;
& span {
  background: url("/assets/img/featured-activity.png") center center / contain no-repeat;
  color: white;
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
  font-weight: 600;
  font-size: 2em;
  text-align: center;
  padding: 0.25em 2em;
  width: auto;
}
@media (max-width: 576px) {
  & span {
    font-size: 1.20em;
  }
}
`
export const NewReleasedHeader = styled(StyledHeader)`
  & span {
    background: url("/assets/svg/new-released.svg") center center / contain no-repeat;
  }
`

export const KitBySkillHeader = styled(StyledHeader)`
  & span {
    background: url("/assets/svg/kit-by-skill.svg") center center / contain no-repeat;
  }
`
export const SkillHeaderInfoCol = styled(Col)`
    text-align: left;
    @media only screen and (max-width: 992px){
        text-align:center
    }
`

export const ActivitiesCoveredHeader = styled(StyledHeader)`
  & span {
    background: url("/assets/svg/activities-covered.svg") center center / contain no-repeat;
  }
`

export const StyledButton = styled.button`
  background-repeat: no-repeat !important;
  background-size: contain !important;
  border: none;
  padding: 16px;
  background-position: center !important;
  font-weight: bold;
  font-size: 1.2em;
  vertical-align: middle;
  margin-right: 10px
`

export const ShowMoreButton = styled(StyledButton)`
  background: url(/assets/svg/show-more.svg);
`

export const ShowAllButton = styled(StyledButton)`
  background: url(/assets/svg/show-all-kits.svg);
`

export const TryFreeButton: FC<ButtonProps> = styled(Button)`
  color: black;
  font-weight: bold;
  padding: 12px;
  background-color: var(--bs-secondary);
  border-color: var(--bs-secondary);
  border-radius: 20px;
`

export const AddToCartButton: FC<ButtonProps> = styled(Button)`
  color: black;
  background-color: #ffdd00;
  border-color: #ffdd00;
  border-radius: 12px;
  font-size: 15px;
  &:hover {
    color: black;
    background-color: #e6c700;
    border-color: #e6c700;
  }
`

export const StyledProductBadgeSpan = styled.span`
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  margin: 5px;
  padding-left: 10px;
  padding-right: 10px;
  font-size: 1.3em;
  display: inline-block
`

export const StyledProductAgeSpan = styled(StyledProductBadgeSpan)`
  background: url('/assets/svg/product-age-badge.svg');
  color: #fff;
  background-size: cover;
`
export const StyledProductSkillSpan = styled(StyledProductBadgeSpan)`
  background: url('/assets/svg/product-skill-badge.svg');
  color: #fff;
  background-size: cover;
`

export const StyledBox = styled.div`
  position: absolute;
  text-align: left;
  font-weight: bolder;
  font-size: 1.5em;
  @media (max-width: 601px) {
    font-size: 1.1em;
    & > img {
      max-width: 320px;
    }
  }
`

export const StyledVideoRow = styled(Row)`
  display: flex;
  flex-wrap: wrap;
  padding-top: 10px;
  padding-bottom: 10px;
  background: url(/assets/svg/product-detail-video.svg) no-repeat;
  background-size: cover;
  border-radius: 20px;
  padding-top: 50px;
  color: rgb(101, 48, 217);
  & b{
    display: block;
    line-height: 0.9;
  }
  & .lg-word{
    display: block;
    line-height: 0.7;
  }
  @media (max-width: 576px) {
    background: #fdd411;
    border-radius: 0;
  }
`


export const StyledProductList = styled.div`
  & .hidden-sm{
    display: block;
  }
  & .hidden-md{
    display: none;
  }

  @media (max-width: 626px) {
    & .hidden-sm{
      display: none;
    }
    & .hidden-md{
      display: block;
    }
  }
`
